import React from 'react';
import { comparisonData } from '../../data/mock';

const ComparisonTable = () => {
  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Compare The Best Treatment For You
          </h2>
          <p className="text-sm sm:text-lg text-gray-500 max-w-2xl mx-auto">
            Understand the differences between treatment methods to make an informed decision
          </p>
        </div>

        {/* Table Container */}
        <div className="overflow-x-auto rounded-xl sm:rounded-2xl border border-gray-200 shadow-sm">
          <table className="w-full min-w-[600px] sm:min-w-[800px]">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="text-left py-3 sm:py-5 px-3 sm:px-6 text-[10px] sm:text-xs font-semibold tracking-wider text-gray-500 uppercase">
                  Feature
                </th>
                <th className="text-center py-3 sm:py-5 px-2 sm:px-4">
                  <div className="font-bold text-gray-900 text-xs sm:text-lg">ESWL</div>
                  <div className="text-[8px] sm:text-xs text-gray-400 tracking-wider uppercase">Shock Wave</div>
                </th>
                <th className="text-center py-3 sm:py-5 px-2 sm:px-4">
                  <div className="font-bold text-gray-900 text-xs sm:text-lg">URSL</div>
                  <div className="text-[8px] sm:text-xs text-gray-400 tracking-wider uppercase">Laser</div>
                </th>
                <th className="text-center py-3 sm:py-5 px-2 sm:px-4">
                  <div className="font-bold text-gray-900 text-xs sm:text-lg">PCNL</div>
                  <div className="text-[8px] sm:text-xs text-gray-400 tracking-wider uppercase">Keyhole</div>
                </th>
                <th className="text-center py-3 sm:py-5 px-2 sm:px-4">
                  <div className="font-bold text-gray-900 text-xs sm:text-lg">Open Surgery</div>
                  <div className="text-[8px] sm:text-xs text-gray-400 tracking-wider uppercase">Traditional</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr
                  key={index}
                  className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                  }`}
                >
                  <td className="py-3 sm:py-5 px-3 sm:px-6 text-[10px] sm:text-sm font-medium text-gray-900">
                    {row.feature}
                  </td>
                  <td className="py-3 sm:py-5 px-2 sm:px-4 text-center text-[10px] sm:text-sm text-gray-600">
                    {row.eswl}
                  </td>
                  <td className="py-3 sm:py-5 px-2 sm:px-4 text-center text-[10px] sm:text-sm text-gray-600">
                    {row.ursl}
                  </td>
                  <td className="py-3 sm:py-5 px-2 sm:px-4 text-center text-[10px] sm:text-sm text-gray-600">
                    {row.pcnl}
                  </td>
                  <td className="py-3 sm:py-5 px-2 sm:px-4 text-center text-[10px] sm:text-sm text-gray-600">
                    {row.openSurgery}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Disclaimer */}
        <p className="text-center text-xs sm:text-sm text-gray-400 mt-4 sm:mt-6">
          Treatment recommendations depend on individual conditions. Consult a specialist for personalized advice.
        </p>
      </div>
    </section>
  );
};

export default ComparisonTable;
